// Appends the signed-in user's id to every /api/chat/ request so the backend can
// enforce per-user access restrictions. The React app authenticates every call
// as the shared `apiuser`, so the real end user is otherwise invisible to the
// custom PHP endpoints — they read it from this `user_id` query param.
//
// Installed once, globally, by wrapping window.fetch. It covers the many local
// `authFetch` helpers and plain fetch() calls across the app without touching
// each call site. The axios path (api.chatRequest) injects the id itself.
// Enforcement is still done server-side; this just makes the id available.

export const currentUserId = () => {
  try { return (JSON.parse(sessionStorage.getItem('user') || 'null') || {}).id || null; }
  catch (e) { return null; }
};

// Add user_id to a /api/chat/ URL string if it isn't already present.
export const withUserId = (url) => {
  if (typeof url !== 'string' || url.indexOf('/api/chat/') === -1) return url;
  if (/[?&]user_id=/.test(url)) return url;
  const uid = currentUserId();
  if (!uid) return url;
  return url + (url.indexOf('?') === -1 ? '?' : '&') + 'user_id=' + encodeURIComponent(uid);
};

export function installChatUserIdInjector() {
  if (typeof window === 'undefined' || window.__chatUserIdInjected) return;
  const orig = window.fetch ? window.fetch.bind(window) : null;
  if (!orig) return;
  window.__chatUserIdInjected = true;
  window.fetch = (input, init) => {
    try {
      if (typeof input === 'string') input = withUserId(input);
    } catch (e) { /* never break fetch */ }
    return orig(input, init);
  };
}
